import type { TCountryCode } from "countries-list";
import { useTranslation } from "gatsby-plugin-react-i18next";
import type { FC } from "react";
import { AppDispatchContext } from "../../context/app/context";
import { useDispatchContext } from "../../hooks/use-dispatch-context";
import SiteSelectModal, {
	type SiteSelectionDropdownOption,
} from "./SiteSelectModal";

type SiteSelectModalContainerProps = {
	recommendedCountry?: TCountryCode;
};

const SiteSelectModalContainer: FC<SiteSelectModalContainerProps> = ({
	recommendedCountry,
}) => {
	const { t } = useTranslation();

	const appDispatch = useDispatchContext(AppDispatchContext);

	const goToPage = (selectedSite: SiteSelectionDropdownOption) => {
		if (selectedSite.isSameSite === true) {
			appDispatch({
				type: "setUserCountry",
				userCountry: selectedSite.country,
			});
		} else {
			window.location.assign(selectedSite.url);
		}
	};

	return (
		<SiteSelectModal
			recommendedCountry={recommendedCountry}
			title={t("Welcome to Babybjörn")}
			preambleCountryExists={t(
				"Based on your location we have the following shipping region for you:",
			)}
			preambleCountryNotFound={t(
				"Unfortunately, it appears that we currently do not ship to your region. However, feel free to browse the site in any of the following countries:",
			)}
			closeButtonLabel={t("Continue")}
			buttonOnClick={goToPage}
		/>
	);
};
export default SiteSelectModalContainer;
